// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The class describes the layout engine state at a particular path step.
 * The state of the last performed step is the command result.
 */
export class LayoutEngineState {
    constructor(grid, moves = new Array(), conflicts = null) {
        this.grid = grid;
        this.moves = moves;
        this.conflicts = conflicts;
    }
}
//# sourceMappingURL=engine-state.js.map